import React from 'react';
import './Sectors.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const SectorCard = ({ backgroundImage, icon, title, description, index }) => {
  const cardRef = useScrollAnimation(index * 150);
  
  return (
    <div ref={cardRef} className="sector-card animate-on-scroll animate-fade-in-up">
      <div className="card-image" style={{ backgroundImage: `url('${backgroundImage}')` }}>
      </div>
      <div className="floating-title">
        <h3 className="card-title">{title}</h3>
        <div className="card-icon">
          <img src={icon} alt={`${title} Icon`} />
        </div>
      </div>
      <div className="card-content">
        <p className="card-description">
          {description}
        </p>
      </div>
    </div>
  );
};

const Sectors = () => {
  const headerRef = useScrollAnimation(100);
  
  const sectorsData = [
    {
      backgroundImage: "/1.png",
      icon: "/small_1.png",
      title: "القطاع التقني والرقمي",
      description: "وسع نطاقك وعرف جمهورك بحلولك التقنية والرقمية عبر استراتيجيات تسويق مبتكرة توضح القيمة الحقيقية لمنتجاتك وتجعلها الخيار الأذكى للمستخدمين."
    },
    {
      backgroundImage: "/2.png",
      icon: "/small_2.png",
      title: "القطاع العقاري",
      description: "اجذب المستثمرين والمشترين بسهولة عبر وكالات متخصصة تعرف كيف تبرز مشاريعك العقارية وتعرضها بأسلوب احترافي يرفع من قيمتها ويجعلها الخيار الأول."
    },
    {
      backgroundImage: "/3.png",
      icon: "/small_3.png",
      title: "التجزئة والتجارة الإلكترونية",
      description: "زد مبيعاتك وتوسع بمتجرك مع وكالات تسويقية تفهم سلوك المستهلك وتبرع في بناء حملات إعلانية ذكية تزيد من وصولك وتحول متجرك إلى علامة تجارية رائدة."
    },
    {
      backgroundImage: "/4.png",
      icon: "/small_4.png",
      title: "القطاع الطبي",
      description: "ابن الثقة مع جمهورك وقدم خدماتك الصحية بصورة تلامس احتياجاتهم الحقيقية من خلال وكالات تسويق خبيرة في التواصل الأخلاقي والفعال في القطاع الطبي."
    }
  ];

  return (
    <section id="sectors" className="sectors-section">
      <div ref={headerRef} className="sectors-header animate-on-scroll animate-fade-in-up">
        <h2 className="sectors-title">
          ابحث عن الوكالة التسويقية التي تعرف قطاعك وتفهم تحدياته
        </h2>
      </div>

      <div className="sectors-cards">
        {sectorsData.map((sector, index) => (
          <SectorCard
            key={index}
            backgroundImage={sector.backgroundImage}
            icon={sector.icon}
            title={sector.title}
            description={sector.description}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default Sectors;


